import clsx from "clsx";
import { Switch as SwitchPrimitives } from "radix-ui";
import React from "react";
import styles from "./switch.module.scss";

export type SwitchProps = Omit<
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>,
  "onCheckedChange"
> & {
  label?: string;
  id?: string;
  onChange?: (checked: boolean) => void;
};

export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, label, id: idProp, onChange, ...props }, ref) => {
  const generatedId = React.useId();
  const switchId = idProp || generatedId;

  return (
    <div className={styles.container}>
      {label && (
        <label htmlFor={switchId} className={styles.label}>
          {label}
        </label>
      )}
      <SwitchPrimitives.Root
        className={clsx(styles.root, className)}
        ref={ref}
        id={switchId}
        onCheckedChange={onChange}
        {...props}
      >
        <SwitchPrimitives.Thumb className={styles.thumb} />
      </SwitchPrimitives.Root>
    </div>
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;
